import { useState } from 'react';

import { Dialog } from '@components/dialog/Dialog';

import { isGoogleAnalyticsAvailable } from '@common/utils/tracking';
import { NewsletterPopUpRecord, NewsletterSignUpLocation } from '@interfaces';

import styles from './newsletter-pop-up.module.scss';
import { NewsletterPopUpContent } from './NewsletterPopUpContent';

interface NewsletterPopUpProps {
	location: NewsletterSignUpLocation;
	popUp: NewsletterPopUpRecord;
}

export const NewsletterPopUp = ({ location, popUp }: NewsletterPopUpProps) => {
	const storageKey =
		typeof Storage === 'function'
			? `list_${popUp.form.mailchimpListId}`
			: undefined;

	const [isSubscribed] = useState(() => {
		if (storageKey) {
			return Boolean(window.localStorage.getItem(storageKey));
		}

		return false;
	});

	const showAfter = popUp.delay * 1000;

	const onClose = () => {
		if (isGoogleAnalyticsAvailable()) {
			ga('send', 'event', {
				eventAction: 'close',
				eventCategory: 'Pop-up',
				eventLabel: `${popUp.form.mailchimpListId} / ${location}`,
				nonInteraction: true,
			});
		}
	};

	if (isSubscribed) {
		return null;
	}

	return (
		<Dialog
			classNames={{
				container: styles.container,
				dialog: styles.dialog,
				closeButton: styles.closeButton,
				title: 'sr-only',
			}}
			closeButtonLabel="Close newsletter pop-up"
			id="newsletter-pop-up-dialog"
			onClose={onClose}
			showAfter={showAfter}
			title="Newsletter pop-up"
			withScrollLock={false}
		>
			<NewsletterPopUpContent
				location={location}
				popUp={popUp}
				storageKey={storageKey}
			/>
		</Dialog>
	);
};
